<template>
  <span
    class="upload-state"
    :class="'state-' + defaultVal"
    v-bind="$attrs"
    @click.stop="click"
    >{{ stateLabel[defaultVal] || '' }}</span
  >
</template>
<script>
export default {
  name: 'upload-state',
  props: {
    scope: Object,
  },
  data() {
    return {
      stateLabel: ['等待上传', '上传中', '上传成功', '上传失败'],
    }
  },
  computed: {
    defaultVal() {
      return this.$getPropValue(this.scope.row, this.scope.column.property)
    },
  },
}
</script>
<style lang="less">
.upload-state {
  &.state-2 {
    color: #67c23a;
  }
  &.state-3 {
    color: #f56c6c;
  }
}
</style>